import { phoneRegExp } from 'components/iam/partners/helpers'
import * as Yup from 'yup'

export const getInitialValues = assignment => ({
  firstName: assignment?.firstName || '',
  lastName: assignment?.lastName || '',
  email: assignment?.email || '',
  phone: assignment?.phone || '',
  emailNotProvided: !assignment?.email || false,
  phoneNotProvided: !assignment?.phone || false,
  details: assignment?.details || ''
})

export const getValidationSchema = () => {
  return Yup.object().shape({
    firstName: Yup.string().required('First name is required'),
    lastName: Yup.string().required('Last name is required'),
    email: Yup.string()
      .email('Invalid email')
      .when('emailNotProvided', ([emailNotProvided], schema) =>
        emailNotProvided ? schema.nullable() : schema.required('Email is required')
      ),
    phone: Yup.string().when('phoneNotProvided', ([phoneNotProvided], schema) =>
      phoneNotProvided
        ? schema.nullable()
        : schema.matches(phoneRegExp, 'Phone number is invalid').required('Phone is required')
    ),
    details: Yup.string().nullable()
  })
}
